// This is a Mixin that allow scrollTo behaviour on new RWD pages or
// components.
var MpScrollTo = {
    created: function () {},

    data: function() {},

    computed: {},

    methods: {

        activateScrolls: function() {
            document.querySelectorAll('.scroll-to[href^="#"]').forEach((el) => {
                el.addEventListener('click', (ev) => {
                    ev.preventDefault();

                    const destination = document.querySelector('#' + ev.currentTarget.href.split('#')[1]);
                    destination.scrollIntoView({ behavior: 'smooth' });
                });
            });
        },
    },

    mounted: function() {
        this.activateScrolls();
    }
};
